module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "card": "",
      "light": "",
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "sm4": "",
      "xs4": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "autofocus": "",
      "label": "Фильтр",
      "solo": "",
      "flat": ""
    },
    model: {
      value: (_vm.cxt.filterString),
      callback: function($$v) {
        _vm.$set(_vm.cxt, "filterString", $$v)
      },
      expression: "cxt.filterString"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-scroll', {
    attrs: {
      "md": "",
      "flat": "",
      "height": _vm.calcDialogScroll(48 + 52)
    }
  }, [_c('v-calc-panel', {
    model: {
      value: (_vm.calc),
      callback: function($$v) {
        _vm.calc = $$v
      },
      expression: "calc"
    }
  }), _vm._v(" "), _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.showDetails,
      "caption": this.showDetails ? 'Кратко' : 'Подробно',
      "expandable": true
    },
    on: {
      "click": function($event) {
        _vm.showDetails = !_vm.showDetails
      }
    }
  }, [_c('span', [_vm._v("Сумма основного долга: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.calc.result.sum, _vm.formats.formatNumber)) + " руб.")])]), _vm._v(" "), _c('span', [_vm._v("Сумма процентов: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.calc.result.profit, _vm.formats.formatNumber)) + " pуб.")])]), _vm._v(" "), _c('span', [_vm._v("ИТОГО: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.calc.result.total, _vm.formats.formatNumber)) + " pуб.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Гос. пошлина: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.calc.result.duties, _vm.formats.formatNumber)) + " pуб.")])])]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDetails),
      expression: "showDetails"
    }]
  }, [_c('table', {
    staticClass: "report_table",
    staticStyle: {
      "width": "100%",
      "min-width": "500px",
      "border-collapse": "collapse"
    },
    attrs: {
      "border": "1",
      "cellpadding": ""
    }
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Cумма операции, в руб.")]), _vm._v(" "), _c('th', [_vm._v("Долг, в руб.")]), _vm._v(" "), _c('th', [_vm._v("С")]), _vm._v(" "), _c('th', [_vm._v("По")]), _vm._v(" "), _c('th', [_vm._v("Дней")]), _vm._v(" "), _c('th', [_vm._v("Ставка")]), _vm._v(" "), _c('th', [_vm._v("Неустойка")])]), _vm._v(" "), _vm._l((_vm.calc.details), function(item) {
    return [(item.amount > 0) ? _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.formats.blank(item.amount, _vm.formats.formatNumber)))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(item.start)))]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v(_vm._s(_vm.formatNote(item.ref)))]), _vm._v(" "), _c('td')]) : _vm._e(), _vm._v(" "), (item.amount < 0) ? _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.formats.blank(item.sum, _vm.formats.formatNumber)))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(item.start)))]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v(_vm._s(_vm.formatNote(item.ref)) + " на " + _vm._s(_vm.formats.blank(item.amount, _vm.formats.formatNumber)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(item.profit ? _vm.formats.blank(item.profit, _vm.formats.formatNumber) : ''))])]) : _vm._e(), _vm._v(" "), (item.amount == null) ? _c('tr', [_c('td'), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.formats.blank(item.sum, _vm.formats.formatNumber)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(item.start)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(item.end)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.formats.blank(item.days, _vm.formatNumber)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.formats.blank(item.rate, _vm.formatPercent)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.formats.blank(item.profit, _vm.formatNumber)))])]) : _vm._e()]
  })], 2)])])], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.ok()
      }
    }
  }, [_vm._v("Сохранить")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-ops-btn', {
    attrs: {
      "cxt": _vm.cxt
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbf1741","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assist/fields/CalcForm.vue
// module id = 945
// module chunks = 1